import { Box, Text, Link } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const GeneralInfo = () => {
  const { t } = useTranslation(['integrations']);
  return (
    <Box>
      <Box mb={12}>
        <Text fontSize="md" fontWeight={600}>
          {t('integrations:overview')}
        </Text>
        <Text fontSize="xs">{t('integrations:rippling.overviewContent')}</Text>
      </Box>
      <Box>
        <Text fontSize="md" fontWeight={600}>
          {t('integrations:whatHeading')}
        </Text>
        <Text fontSize="xs">{t('integrations:rippling.whatHeadingContent')}</Text>

        <Link
          href="https://help.timeero.com/timeero-rippling-integration"
          color="secondary.500"
          fontSize="xs"
          fontWeight="semibold"
          isExternal
        >
          {t('integrations:learnToStart')}
        </Link>
      </Box>
    </Box>
  );
};
export default GeneralInfo;
